import React from 'react';
import { Redirect } from 'react-router-dom';

const NoRoute = () => {
  return <Redirect to="/login" />;
};

export default NoRoute;
